import React from 'react';
import NeonWordmark from './NeonWordmark';

// Neon "chat and date" logo — served locally from /public so it's cached,
// works offline for the PWA, and doesn't depend on the external CDN.
export const WORLDVIBE_LOGO = '/logo.jpeg';

export default function Logo({ size = 'md', showText = false, className = '', animate = false }) {
  const sizes = { sm: 40, md: 48, lg: 72, xl: 128 };
  const textSizes = { sm: 'text-lg', md: 'text-xl', lg: 'text-3xl', xl: 'text-5xl' };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className={`relative ${animate ? 'neon-boot' : ''}`}>
        {/* Neon cyan/violet/pink glow behind the logo */}
        <div
          className={`absolute inset-0 rounded-2xl blur-md opacity-70 ${animate ? 'neon-boot-glow' : ''}`}
          style={{ background: 'linear-gradient(135deg,#22D3EE,#8B5CF6,#EC4899)' }}
        />
        <img
          src={WORLDVIBE_LOGO}
          alt="WorldVibe — chat and date"
          width={s}
          height={s}
          className="relative rounded-2xl object-cover ring-2 ring-white/20"
          style={{ width: s, height: s }}
        />
      </div>
      {showText && (
        <NeonWordmark
          className={`font-display font-bold tracking-tight ${textSizes[size]}`}
          animate={animate}
        />
      )}
    </div>
  );
}
